module.exports = __webpack_public_path__ + "img/d.4dca575f.jpg";